import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../lib/data";

export const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer
            data-testid="site-footer"
            className="bg-secondary text-secondary-foreground border-t border-border"
        >
            <div className="px-6 md:px-12 lg:px-24 py-20">
                <div className="grid md:grid-cols-12 gap-10 md:gap-6">
                    <div className="md:col-span-5">
                        <div className="font-mono text-xs tracking-[0.3em] uppercase text-accent mb-4">
                            {COMPANY.tagline}
                        </div>
                        <h3 className="font-display font-black text-3xl sm:text-4xl uppercase tracking-tight leading-[0.9]">
                            We appreciate the opportunity to{" "}
                            <span className="text-accent">BUILD</span> with you.
                        </h3>
                        <p className="mt-6 text-secondary-foreground/70 max-w-md leading-relaxed">
                            Commercial construction in Fresno, CA since {COMPANY.founded}. From
                            concept to completion — we Listen. Plan. Build.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-mono text-xs tracking-[0.2em] uppercase text-secondary-foreground/50 mb-4">
                            Sitemap
                        </div>
                        <ul className="space-y-3">
                            {[
                                ["Home", "/"],
                                ["Services", "/services"],
                                ["Projects", "/projects"],
                                ["People & Culture", "/about"],
                                ["Plan Room", "/plan-room"],
                                ["Contact", "/contact"],
                            ].map(([label, href]) => (
                                <li key={href}>
                                    <Link
                                        to={href}
                                        data-testid={`footer-link-${label.toLowerCase()}`}
                                        className="text-secondary-foreground/80 hover:text-accent transition-colors text-sm uppercase tracking-wider"
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="font-mono text-xs tracking-[0.2em] uppercase text-secondary-foreground/50 mb-4">
                            Contact
                        </div>
                        <ul className="space-y-4 text-sm">
                            <li className="flex items-start gap-3">
                                <MapPin className="w-4 h-4 text-accent mt-1 shrink-0" />
                                <span>{COMPANY.address}</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <Phone className="w-4 h-4 text-accent mt-1 shrink-0" />
                                <a href={`tel:${COMPANY.phone}`} className="hover:text-accent">
                                    {COMPANY.phone}
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail className="w-4 h-4 text-accent mt-1 shrink-0" />
                                <a href={`mailto:${COMPANY.email}`} className="hover:text-accent break-all">
                                    {COMPANY.email}
                                </a>
                            </li>
                        </ul>

                        <Link
                            to="/contact"
                            data-testid="footer-cta"
                            className="mt-8 inline-flex items-center gap-2 bg-accent text-accent-foreground px-5 py-3 text-sm font-bold uppercase tracking-wider hover:bg-background hover:text-foreground transition-colors"
                        >
                            Start your project
                            <ArrowUpRight className="w-4 h-4" />
                        </Link>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-secondary-foreground/15 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
                    <div className="font-mono text-xs text-secondary-foreground/50 uppercase tracking-[0.2em]">
                        © {year} Mark Wilson Construction · 5799 E Clinton Ave, Fresno, CA 93727 · License #774987
                    </div>
                    <div className="font-mono text-xs text-secondary-foreground/50 uppercase tracking-[0.2em]">
                        Listen / Plan / Build
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
